// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","login-otp__request-token-link":"login-otp_login-otp__request-token-link__bpz8R","login-otp__request-token-info":"login-otp_login-otp__request-token-info__-jYTZ"};